export const PRODUCTION_HOSTNAMES = ['dawnprogram.org.au', 'www.dawnprogram.org.au'];

export function isProductionHostname(hostname?: string | null): boolean {
  if (!hostname) {
    return false;
  }

  return PRODUCTION_HOSTNAMES.includes(hostname.split(':')[0]);
}

export function isProductionHost(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  return isProductionHostname(window.location.hostname);
}
